/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { FamilyAndFriendsCodeComponent } from './components/family-and-friends-code-item';
import { IFamilyAndFriendsData } from './family-and-friends.data';
import { IFamilyAndFriendsProps } from './family-and-friends.props.autogenerated';

export interface IFamilyAndFriendsViewProps extends IFamilyAndFriendsProps<IFamilyAndFriendsData> {
    header: React.ReactNode;
    codes: React.ReactNode[] | undefined;
}

/**
 *
 * FamilyAndFriends component
 * @extends {React.PureComponent<IFamilyAndFriendsProps<IFamilyAndFriendsData>>}
 */
class FamilyAndFriends extends React.PureComponent<IFamilyAndFriendsProps<IFamilyAndFriendsData>> {
    public render(): JSX.Element | null {
        this.props.context.actionContext;
        const viewProps: IFamilyAndFriendsViewProps = {
            ...this.props,
            header: this._headerJSX,
            codes: this.props.data.codeList.result?.Result.Codes?.map(
                (code) =>
                    (
                        <FamilyAndFriendsCodeComponent
                            context={this.props.context}
                            resources={this.props.resources}
                            config={this.props.config}
                            code={code}
                            key={code.Code}
                        />
                    )
            )
        };
        return this.props.renderView(viewProps);
    }

    private get _headerJSX(): JSX.Element {
        return (
            <div className='family-friends__table-head'>
                <div className='family-friends__code'>{this.props.resources.familyFriends_codeLabel}</div>
                <div className='family-friends__recipient'>{this.props.resources.familyFriends_recipientLabel}</div>
                <div className='family-friends__activation'>{this.props.resources.familyFriends_activationDateLabel}</div>
            </div>
        );
    }
}

export default FamilyAndFriends;
